import { useEffect, useState } from "react";

type UseTypewriterPlaceholderOptions = {
  phrases: readonly string[];
  inputValue: string;
};

export const useTypewriterPlaceholder = ({ phrases, inputValue }: UseTypewriterPlaceholderOptions) => {
  const [placeholder, setPlaceholder] = useState("");

  useEffect(() => {
    if (inputValue.trim().length > 0) {
      setPlaceholder("");
      return;
    }

    let phraseIdx = 0;
    let charIdx = 0;
    let deleting = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const tick = () => {
      const phrase = phrases[phraseIdx] ?? "";

      if (!deleting) {
        charIdx = Math.min(charIdx + 1, phrase.length);
        setPlaceholder(phrase.slice(0, charIdx));
        if (charIdx === phrase.length) {
          deleting = true;
          timeoutId = setTimeout(tick, 1200);
          return;
        }
        timeoutId = setTimeout(tick, 70);
        return;
      }

      charIdx = Math.max(charIdx - 1, 0);
      setPlaceholder(phrase.slice(0, charIdx));
      if (charIdx === 0) {
        deleting = false;
        phraseIdx = (phraseIdx + 1) % phrases.length;
        timeoutId = setTimeout(tick, 220);
        return;
      }
      timeoutId = setTimeout(tick, 40);
    };

    timeoutId = setTimeout(tick, 150);
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [inputValue, phrases]);

  return placeholder;
};
